import { Button, Stack, Tooltip } from "@mui/material";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import InviteMembersContext from "./InviteMembersContext";

const DistributeCompanyPermissions = () => {
  const { distributePermissions } = useDefinedContext(InviteMembersContext);

  return (
    <Stack>
      <Tooltip placement="top" title="Apply current permissions to all companies" arrow>
        <Button variant="outlined" color="secondary" onClick={distributePermissions}>
          Distribute permissions
        </Button>
      </Tooltip>
    </Stack>
  );
};

export default DistributeCompanyPermissions;
